<template>
  <svg
    class="icon"
    :class="{'icon--spin':spin}"
    :height="size"
    viewBox="0 0 16 16"
    :width="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-width="2"
      style="stroke:currentColor;"
    >
      <path d="m8 3s-4 2.99609375-4 2.99609375h10" />
      <path d="m6 11s-4 2.9960937-4 2.9960937h10" transform="matrix(-1 0 0 -1 14 24.996)" />
    </g>
  </svg>
</template>

<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps(baseIconProps);

</script>
